import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// components
import TabItem from '../../../Components/TabItem';
import { Outlet, useNavigate, useParams } from 'react-router';
import { fetchWrapper } from '../../../_helpers/fetchWrapper';
import { useStateMachine } from 'little-state-machine';
import updateAction from './updateAction';
import { toast } from 'react-toastify';
import { ErrorMessageHandler } from '../../../_helpers/_methods';
import { useSelector } from 'react-redux';
import { useRef } from 'react';
// import { usePrompt } from '../../../_helpers/hooks/useBlocker';
import clearStore from './clearStore';
// icons

const TABS = [
  'event.generalInfo',
  'event.detailedInfo',
  'event.expectedParticipants',
  'event.targetedArea',
  'event.AsipLinkage',
  'event.courses'
];

function EventForm() {
  const location = useLocation();
  const { eventId } = useParams();
  let pathname = location.pathname;
  const lastIndex = pathname.split('/').length - 1;
  const [tab, setTab] = useState(pathname.split('/')[lastIndex]);
  const nagivate = useNavigate();
  const { actions } = useStateMachine({ updateAction, clearStore });

  const user = useSelector((state) => state.user.user);
  const [palicaLoaded, setPalicaLoaded] = useState(false);
  const [oldEventsLoaded, setOldEventsLoaded] = useState(false);
  const [palicaProccessed, setPalicaProcessed] = useState(false);
  const eventsFormRef = useRef({});

  // const resetForm = () => {
  //   actions.clearStore();
  // };
  // usePrompt('message', true, resetForm);

  useEffect(() => {
    return () => {
      actions.clearStore();
    };
  }, []);

  useEffect(() => {
    setTab(pathname.split('/')[lastIndex]);
  }, [pathname]);

  useEffect(() => {
    const getPalikasAndSetProvince = async () => {
      try {
        let url = '/palika/';
        if (user?.active_role !== 'superuser') {
          if (user?.address.length > 0) {
            url = `/palika/?title=${user.address[0].province}`;
          } else {
            return toast.error('User address missing');
          }
        }
        const response = await fetchWrapper.get(url);
        const palikaData = response.data;
        eventsFormRef.current.event = {
          ...eventsFormRef.current.event,
          local_gov_provinces: palikaData
        };
        setPalicaLoaded(true);
      } catch (error) {
        ErrorMessageHandler(error);
      }
    };
    if (user) {
      getPalikasAndSetProvince();
    }
  }, [user]);

  useEffect(() => {
    const getEventsInfo = async () => {
      try {
        const response = await fetchWrapper.get(`/event/${eventId}/`);
        const data = response.data;
        const thematicArea = data.thematic_areas.map((item) => String(item.id));
        let nature = [];
        if (
          !user?.active_role ||
          (user.active_role !== 'superuser' && user.id !== data.created_by.id)
        ) {
          return nagivate(`/events/${eventId}`);
        }

        if (data.nature === 'semi-physical') {
          nature = ['physical', 'online'];
        } else {
          nature = [data.nature];
        }
        let expected_participant_sector = {
          'संघिय तह': [],
          'प्रदेश तह': [],
          'जिल्ला तह': [],
          'स्थानिय तह': []
        };
        data.expected_participant_sector.forEach((sector) => {
          if (expected_participant_sector[sector.parent__title]) {
            expected_participant_sector[sector.parent__title] = [
              ...expected_participant_sector[sector.parent__title],
              String(sector.id)
            ];
          }
        });

        eventsFormRef.current.event = {
          ...eventsFormRef.current.event,
          activity_count: data.activity_count,
          course_links: data.course_links,
          end_date_bs: data.end_date_bs,
          estimated_budget: data.estimated_budget,
          expected_participant_count: data.expected_participant_count,
          expected_participant_sector: expected_participant_sector,
          mtot: [String(data.mtot)],
          nature: nature,
          output_number: { value: data.output_number, label: data.output_number },
          physical_location_details: data.physical_location_details,
          old_targeted_local_gov: data.targeted_local_gov,
          thematic_areas: thematicArea,
          program_type: data.program_type,
          start_date_bs: data.start_date_bs,
          summary: data.summary,
          title_english: data.title_english,
          title_nepali: data.title_nepali,
          virtual_link: data.virtual_link
        };
        setOldEventsLoaded(true);
      } catch (error) {
        console.log(error);
        toast.error('Something went wrong');
        nagivate(`/admin/events`);
      }
    };
    if (eventId) {
      getEventsInfo();
    } else {
      setOldEventsLoaded(true);
    }
  }, [user, eventId]);

  useEffect(() => {
    if (
      eventsFormRef.current.event?.old_targeted_local_gov &&
      eventsFormRef.current.event?.local_gov_provinces
    ) {
      let oldTargetedLocalGov = [...eventsFormRef.current.event.old_targeted_local_gov];
      let temp_localLevel = { provinces: [], local_levels: [], districts: [] };
      let temp_districtLevel = { provinces: [], districts: [] };
      let temp_districtLevel_districts = {};
      let temp_localLevel_districts = {};
      let temp_localLevel_localLevels = {};
      let temp_districtLevel_localLevels = {};

      let indexOfLocalGov = oldTargetedLocalGov.findIndex(
        (localGov) => localGov.type === 'स्थानीय तह' || localGov.type === 'स्थानिय तह'
      );

      // array for local_level_gov
      if (indexOfLocalGov >= 0 && eventsFormRef.current.event?.local_gov_provinces) {
        let localLevels = oldTargetedLocalGov[indexOfLocalGov].local_level;
        let palika = [...eventsFormRef.current.event.local_gov_provinces];

        let provinceIdSet = new Set();
        let districtIdSet = new Set();
        let localLevelSet = new Set();

        localLevels?.forEach((localLevel) => {
          provinceIdSet.add(localLevel.district__province__id);
          districtIdSet.add(localLevel.district__id);
          localLevelSet.add(localLevel.id);

          temp_localLevel.local_levels = [
            ...temp_localLevel.local_levels,
            {
              title: localLevel.title,
              id: localLevel.id
            }
          ];
        });

        let selectedProvinceArray = palika.filter((province) =>
          Array.from(provinceIdSet).includes(province.id)
        );
        let selectedDistrictArray = [];

        selectedProvinceArray.forEach((province) => {
          temp_localLevel_districts[province.id] = {
            parent: province.title,
            parent_en: province.title_en,
            id: province.id,
            children: province.districts
          };
          temp_localLevel.provinces = [...temp_localLevel.provinces, province];
          selectedDistrictArray = province.districts.filter((district) =>
            Array.from(districtIdSet).includes(district.id)
          );
        });

        selectedDistrictArray.forEach((district) => {
          temp_localLevel_localLevels[district.id] = {
            parent: district.title,
            parent_en: district.title_en,
            id: district.id,
            children: district.local_levels
          };
          temp_localLevel.districts = [...temp_localLevel.districts, district];
        });
      }

      // array for district_gov
      let indexOfDistrict = oldTargetedLocalGov.findIndex(
        (localGov) => localGov.type === 'जिल्ला तह'
      );

      if (indexOfDistrict >= 0 && eventsFormRef.current.event?.local_gov_provinces) {
        let districts = oldTargetedLocalGov[indexOfDistrict].districts;
        let palika = [...eventsFormRef.current.event.local_gov_provinces];

        let provinceIdSet = new Set();
        let districtIdSet = new Set();

        districts?.forEach((district) => {
          provinceIdSet.add(district.province__id);
          districtIdSet.add(district.district__id);

          temp_districtLevel.districts = [
            ...temp_districtLevel.districts,
            {
              title: district.title,
              id: district.id
            }
          ];
        });
        let selectedProvinceArray = palika.filter((province) =>
          Array.from(provinceIdSet).includes(province.id)
        );
        let selectedDistrictArray = [];

        selectedProvinceArray.forEach((province) => {
          temp_districtLevel_districts[province.id] = {
            parent: province.title,
            parent_en: province.title_en,
            id: province.id,
            children: province.districts
          };
          temp_districtLevel.provinces = [...temp_districtLevel.provinces, province];
          selectedDistrictArray = province.districts.filter((district) =>
            Array.from(districtIdSet).includes(district.id)
          );
        });

        selectedDistrictArray.forEach((district) => {
          temp_districtLevel_localLevels[district.id] = {
            parent: district.title,
            parent_en: district.title_en,
            id: district.id,
            children: district.local_levels
          };
          temp_districtLevel.districts = [...temp_districtLevel.districts, district];
        });
      }
      let indexOfProvince = oldTargetedLocalGov.findIndex(
        (localGov) => localGov.type === 'प्रदेश तह'
      );
      let prov_provinces = [];
      if (indexOfProvince >= 0 && eventsFormRef.current.event?.local_gov_provinces) {
        prov_provinces = oldTargetedLocalGov[indexOfProvince].provinces;
      }

      eventsFormRef.current.event = {
        ...eventsFormRef.current.event,
        targeted_prov_gov: {
          ...(eventsFormRef.current.event?.targeted_prov_gov || {}),
          province: {
            provinces: prov_provinces
          }
        },
        targeted_dist_gov: {
          ...(eventsFormRef.current.event?.targeted_dist_gov || {}),
          district: temp_districtLevel
        },
        targeted_local_gov: {
          ...(eventsFormRef.current.event?.targeted_local_gov || {}),
          localLevel: temp_localLevel
        },
        localLevel_districts: temp_localLevel_districts,
        localLevel_localLevels: temp_localLevel_localLevels,
        districtLevel_districts: temp_districtLevel_districts,
        districtLevel_localLevels: temp_districtLevel_localLevels
      };
    }
    setPalicaProcessed(true);
  }, [
    eventsFormRef.current.event?.old_targeted_local_gov,
    eventsFormRef.current.event?.local_gov_provinces
  ]);

  useEffect(() => {
    if (oldEventsLoaded && palicaProccessed && palicaLoaded) {
      actions.updateAction({
        event: eventsFormRef.current.event,
        isEventCreationDataLoaded: true
      });
    }
  }, [oldEventsLoaded, palicaProccessed, palicaLoaded]);

  return (
    <div className="card" ref={eventsFormRef}>
      <div className="card-header">
        <ul key={tab} className="nav" id="eventTab" role="tablist">
          {TABS.map((title) => {
            let tabName;
            switch (tab) {
              case 'new':
                tabName = TABS[0];
                break;
              default:
                tabName = TABS[parseInt(tab)];
            }
            return (
              <TabItem title={title} key={title} isActive={title === tabName} className="fs-5" />
            );
          })}
        </ul>
      </div>
      <div className="card-body">
        <Outlet />
      </div>
    </div>
  );
}

export default EventForm;
